export default {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high"
};
